import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'outcome',
  templateUrl: './outcome.component.html',
  styleUrls: ['./outcome.component.sass']
})
export class OutcomeComponent implements OnInit {
  @Input() color: string;
  @Input() content: string;
  
  constructor() { }

  ngOnInit() {
  }

}
